import { useEffect } from 'react';
import { ClientConfigService } from '../../system/service/ClientConfigService';

type In = {
  assetId?: string; // The id given to the asset in our Digital Control Room account (e.g. "c2b41f17").
};

type Out = {
  cookiePolicyUrl: string;
};

const DOMAIN = 'policy.cookiereports.com';
const DEFAULT_ASSET_ID = 'c2b41f17'; // AstraZeneca asset id.

/**
 * Use this hook when you want to display the cookie consent banner and / or open it from a link.
 * If you only want to show the banner you can ignore the return value.
 * If you want to show the banner on click (e.g. in the footer), then use the return value in the link.
 */
export const useCookiePolicy = ({ assetId }: In = {}): Out => {
  const configuredAssetId = ClientConfigService.getCookiePolicyId();
  const idToUse = assetId || configuredAssetId || DEFAULT_ASSET_ID;
  const cookiePolicyUrl = `https://${DOMAIN}/${idToUse}-en-gb.html`;
  const cookiePolicyScriptSrc = `//${DOMAIN}/${idToUse}_panel-en-gb.js`;

  useEffect(() => {
    const scriptFoundInDocument = !!document.querySelector(`script[src="${cookiePolicyScriptSrc}"]`);
    if (!scriptFoundInDocument) {
      const script = document.createElement('script');
      script.src = cookiePolicyScriptSrc;
      script.async = true;
      document.body.appendChild(script);
    }
  }, [cookiePolicyScriptSrc]);

  return { cookiePolicyUrl };
};
